export default "__VITE_ASSET__dJN47X1l__"